export default function PageBackground() {
  return (
    <div className="page-background" aria-hidden="true">
      <div className="page-background__vignette" />
    </div>
  );
}
